exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".watermark-switch[data-v-6d9f3e02]{position:absolute;bottom:40px;left:20px;z-index:10}", "", {"version":3,"sources":["/workspace/src/views/question-review/components/UploadFile/src/main.vue"],"names":[],"mappings":"AACA,mCAAmC,kBAAkB,YAAY,UAAU,UAAU,CACpF","file":"main.vue","sourcesContent":["\n.watermark-switch[data-v-6d9f3e02]{position:absolute;bottom:40px;left:20px;z-index:10\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6d9f3e02","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/question-review/components/UploadFile/src/main.vue
// module id = 2259
// module chunks = 5 34